import React from "react";
import { observer } from "mobx-react";
import { ThemeViewStore } from "../../store";
import { ThemeViewForm } from "./ThemeViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type ThemeViewProps = {
  themeViewStore: ThemeViewStore;
};

export const ThemeView: React.FC<ThemeViewProps> = observer(
  ({ themeViewStore }) => {
    return (
      <div>
        <ThemeViewForm
          name={themeViewStore.nameValue}
          active={themeViewStore.activeValue}
          authoring={themeViewStore.authoringValue}
          resolved={themeViewStore.resolvedValue}
          onPrint={(handlePrint: () => void) =>
            themeViewStore.printTheme(handlePrint)
          }
          onCancel={() => themeViewStore.cancelTheme()}
          onEdit={
            themeViewStore.isEditEnabled
              ? () => themeViewStore.editTheme()
              : undefined
          }
        />
        <ErrorDialog
          open={themeViewStore.errorDialogOpened}
          title={themeViewStore.errorTitle}
          description={themeViewStore.errorDescription}
          onClose={() => themeViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
